export default __webpack_public_path__ + "assets/models/6f41cf0f487e4b45c92be154165fff95.gltf";